import { getAnalytics } from './states';

export const services = {
  getAnalytics,
};
